const PriceNormalization = ({ row }) => {
  return <div>{row?.servicePrice?.toLocaleString()}</div>;
};

export default PriceNormalization;
